import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import TimePicker from '@mui/lab/TimePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateAdapter from '@mui/lab/AdapterMoment';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import { setClaimDraft, setConnectingFlightsDraft } from 'src/actions/claimAction';
import dateIcon from './Date.svg';
import timeIcon from './Time.svg';

const timeStyle = {
  background: 'white',
  border: '1px solid #CAD8FF',
  borderRadius: '12px',
  color: 'black',
  fontFamily: 'Poppins',
  fontSize: '12px',
  margin: '0px',
  padding: '5.225px 11px',
  width: '105px'
};

const dateStyle = {
  background: 'white',
  border: '1px solid #CAD8FF',
  borderRadius: '12px',
  color: 'black',
  fontFamily: 'Poppins',
  fontSize: '12px',
  margin: '0px',
  padding: '5.225px 11px',
  width: '200px'
};

const ClaimDateField = ({ type, value, index, timePicker = true }) => {
  const dispatch = useDispatch();

  const claimDraft = useSelector(({ claims }) => claims.claimDraft);
  const connectingFlights = useSelector(({ claims }) => claims.connectingFlights);

  const handleChange = (dateValue, timeValue) => {
    if (!dateValue || !moment(dateValue).isValid()) {
      return;
    }

    const finalValue = moment(dateValue).toDate();

    if (!moment(finalValue).isValid()) {
      return;
    }

    if (timeValue) {
      finalValue.setHours(moment(timeValue).toDate().getHours());

      finalValue.setMinutes(moment(timeValue).toDate().getMinutes());
    }

    switch (type) {
      case 'connectingArrivalTime':
      case 'actualConnectingArrivalTime':
        if (finalValue === null) {
          connectingFlights[index] = {
            ...connectingFlights[index],
            [type]: ''
          };
          dispatch(setConnectingFlightsDraft([...connectingFlights]));
        } else {
          connectingFlights[index] = {
            ...connectingFlights[index],
            [type]: new Date(finalValue)
          };
          dispatch(setConnectingFlightsDraft([...connectingFlights]));
        }
        break;

      default:
        if (!finalValue) {
          dispatch(setClaimDraft({ ...claimDraft, [type]: '' }));
        } else {
          dispatch(setClaimDraft({ ...claimDraft, [type]: new Date(finalValue) }));
        }

        break;
    }
  };

  const handleDateChange = (dateValue) => {
    if (!moment(dateValue).isValid()) {
      return;
    }

    handleChange(dateValue, value);
  };

  const handleTimeChange = (timeValue) => {
    if (!moment(timeValue).isValid()) {
      return;
    }

    handleChange(value, moment(timeValue).toDate());
  };

  return (
    <LocalizationProvider dateAdapter={DateAdapter}>
      <DesktopDatePicker
        clearable
        clearText="clear me"
        components={{
          OpenPickerIcon: () => <img alt="date picker" src={dateIcon} />
        }}
        inputFormat="DD/MM/yyyy"
        InputProps={{
          disableUnderline: true,
          style: dateStyle
        }}
        onChange={handleDateChange}
        renderInput={(params) => <TextField {...params} />}
        value={value}
      />

      {timePicker && (
        <TimePicker
          ampm={false}
          clearable
          components={{
            OpenPickerIcon: () => <img alt="date picker" src={timeIcon} />
          }}
          inputFormat="HH:mm"
          InputProps={{
            disableUnderline: true,
            style: timeStyle
          }}
          onChange={handleTimeChange}
          renderInput={(params) => <TextField {...params} />}
          value={value}
        />
      )}
    </LocalizationProvider>
  );
};

export default ClaimDateField;
